import localFont from "next/font/local"

/**
 * PERFORMANCE-OPTIMIZED FONT LOADING
 * 
 * Critical fonts (preloaded): Only 400 + 600 for above-fold content
 * - Regular (400): Body text, descriptions
 * - SemiBold (600): Buttons, headings, navigation
 * 
 * Other weights load on-demand via CSS when needed (not preloaded).
 * This reduces initial font load from ~850KB (14 files) to ~120KB (2 files).
 */
const Saans = localFont({
    variable: "--font-dashboard",
    display: "swap",
    preload: false,
    fallback: ["system-ui", "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "sans-serif"],
    adjustFontFallback: "Arial", // Minimize CLS during font load
    src: [
        // CRITICAL (preloaded) - Above-fold content only
        // Regular (400) - Body text
        {
            path: "../../public/fonts/woff2/saans-regular.woff2",
            weight: "400",
            style: "normal"
        },
        // SemiBold mapped to 600 - Buttons, navigation, emphasis
        {
            path: "../../public/fonts/woff2/saans-semibold.woff2",
            weight: "600",
            style: "normal"
        },
        
        // NON-CRITICAL (lazy-loaded by browser on demand)
        // These are declared but NOT preloaded - browser fetches when CSS rules need them
        // Light (300)
        {
            path: "../../public/fonts/woff2/saans-light.woff2",
            weight: "300",
            style: "normal"
        },
        // Regular italic (400)
        {
            path: "../../public/fonts/woff2/saans-regularitalic.woff2",
            weight: "400",
            style: "italic"
        },
        // Medium (500)
        {
            path: "../../public/fonts/woff2/saans-medium.woff2",
            weight: "500",
            style: "normal"
        },
        // Bold (700)
        {
            path: "../../public/fonts/woff2/saans-bold.woff2",
            weight: "700",
            style: "normal"
        },
        // Heavy (800)
        {
            path: "../../public/fonts/woff2/saans-heavy.woff2",
            weight: "800",
            style: "normal"
        }
    ]
})

// Export as both Saans (new name) and GTWalsheimPro (backwards compatibility)
// This allows gradual migration of imports
const GTWalsheimPro = Saans

export { Saans, GTWalsheimPro }
